import { Outlet } from "react-router";
import {
  ArrowTrendingUpIcon,
  BoltIcon,
  ChatBubbleLeftRightIcon,
  DocumentChartBarIcon,
  InboxIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline";

import { Card } from "../../../../common/Atoms/Card";
import { Tabs } from "../../../../common/Atoms/Tabs";

export function EscalationTableSectionRoot() {
  const tabs = [
    {
      name: `Notes`,
      href: ``,
      icon: PencilSquareIcon,
    },
    {
      name: `Invoices`,
      href: `invoices`,
      icon: InboxIcon,
    },
    {
      name: `Comms`,
      href: `comms`,
      icon: ChatBubbleLeftRightIcon,
    },
    {
      name: `Statement`,
      href: `statement`,
      icon: DocumentChartBarIcon,
    },
    {
      name: `Actions`,
      href: `activity`,
      icon: BoltIcon,
    },
    {
      name: `All Escalations`,
      href: `tasks`, // Different name for navigation highlight
      icon: ArrowTrendingUpIcon,
    },
  ];

  return (
    <div>
      <Card>
        <Tabs
          tabs={ tabs }
        />
        <Outlet />
      </Card>
    </div>
  );
}
